export const isDepartmentAllow = (departments, userDepartment) => {
  return departments.includes(userDepartment?.alias)
}

export default {
  isDepartmentAllow,
}
